<template>
  <div class="saved">
    <Navbar />
    <div class="mt-5 pt-5 kovatek-width">
        <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
            <div class="text-left mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back">Go Back</span></div>  
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8">
                    <div class="mb-5">
                        <a-tabs defaultActiveKey="1">
                            <a-tab-pane tab="Developers I’ve worked with" key="1">
                                <div class="p-4 bg-light border shadow-sm add-rounded">
                                        <div :key="engagedTalent" v-for="engagedTalent in engagedTalents">
                                            <div class="row">
                                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                            </div>
                                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                                <h5 class="font-weight-bolder"><router-link to="/dev-profile"><span class="kova-text">{{engagedTalent.Setting.Firstname}} {{engagedTalent.Setting.Surname}}</span></router-link>
                                                    <img class="ml-1 ml-md-2 mb-1" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                                                    <span class="ml-3"><img class="mr-1 rating" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1 kova-green">{{engagedTalent.SkillScore}}</span><span class="ml-2 ctrl-size-2 kova-light">{{engagedTalent.Reviews}} reviews</span></span>
                                                </h5>
                                                <p>
                                                    <span class="font-italic">{{engagedTalent.Speciality}}</span> <span class="ml-3 text-uppercase intermediate">{{ computeLevel(engagedTalent.SeniorityLevel) }}</span> 
                                                    <span class="font-weight-bolder ctrl-size-2 ml-3"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark mr-1"></font-awesome-icon>{{engagedTalent.City}}, {{engagedTalent.Country}}</span>
                                                </p>

                                                <!-- <span>
                                                    <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                                                    <span class="font-weight-light">{{work.duration}}</span>
                                                </span> -->
                                                <p class="text-size2" v-html="engagedTalent.AboutMe">... 
                                                    </p>
                                                    <router-link :to="`/dev-profile?id=${engagedTalent.UserID}`">
                                                    <span class="ant-color pointer">see more</span>
                                                    </router-link>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded"  v-for="skill in mergeSkills(engagedTalent.CoreTechstack, engagedTalent.OtherCoreTechstacks)" :key="skill">
                                                        {{skill}}</span>
                                                        <span class="px-3 py-2 mr-3 mb-3 rounded" style="background-color: #EFEFEF">
                                                        <b>+ more</b></span>
                                                </div>
                                            </div>
                                            
                                            <!-- <div class="col-md-3">

                                            </div> -->
                                            <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text">
                                                <h6 class="font-weight-bolder kova-light ctrl-size-3">Project completed: {{engagedTalent.ProjectsCompleted}}</h6>
                                                <h6 class="font-weight-bolder kova-light ctrl-size-3">Team Work: 4</h6>
                                            <div class="pt-0 mt-1 mt-md-5 pt-md-5">
                                                <font-awesome-icon :icon="['fas', 'bookmark']" class="kova-light" style="font-size: 24px;"></font-awesome-icon>
                                            </div>
                                            <!-- <h6>{{work.hours}} hours </h6> -->
                                            <!-- <span class="ml-2"><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span> -->

                                            </div>
                                        </div>
                                        <hr>
                                        </div>
                                        
                                    </div>
                            </a-tab-pane>
                            <a-tab-pane tab="Saved developers proﬁle" key="2" forceRender>
                                <div class="mt-4 mb-5">
                                    <div class="p-4 bg-light border shadow-sm add-rounded">
                                        <div :key="savedTalent" v-for="savedTalent in savedTalents">
                                            <div class="row">
                                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                            </div>
                                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                                <h5 class="font-weight-bolder"><router-link to="/dev-profile"><span class="kova-text">{{savedTalent.Setting.Firstname}} {{savedTalent.Setting.Surname}}</span></router-link>
                                                    <img class="ml-1 ml-md-2 mb-1" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                                                    <span class="ml-3"><img class="mr-1 rating" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1 kova-green">{{savedTalent.SkillScore}}</span><span class="ml-2 ctrl-size-2 kova-light">{{savedTalent.Reviews}} reviews</span></span>
                                                </h5>
                                                <p>
                                                    <span class="font-italic">{{savedTalent.Speciality}}</span> <span class="ml-3 text-uppercase intermediate">{{ computeLevel(savedTalent.SeniorityLevel) }}</span> 
                                                    <span class="font-weight-bolder ctrl-size-2 ml-3"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark mr-1"></font-awesome-icon>{{savedTalent.City}}, {{savedTalent.Country}}</span>
                                                </p>

                                                <!-- <span>
                                                    <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                                                    <span class="font-weight-light">{{work.duration}}</span>
                                                </span> -->
                                                <p class="text-size2" v-html="savedTalent.AboutMe">... 
                                                    </p>
                                                    <router-link :to="`/dev-profile?id=${savedTalent.UserID}`">
                                                    <span class="ant-color pointer">see more</span>
                                                    </router-link>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded"  v-for="skill in mergeSkills(savedTalent.CoreTechstack, savedTalent.OtherCoreTechstacks)" :key="skill">
                                                        {{skill}}</span>
                                                        <span class="px-3 py-2 mr-3 mb-3 rounded" style="background-color: #EFEFEF">
                                                        <b>+ more</b></span>
                                                </div>
                                            </div>
                                            
                                            <!-- <div class="col-md-3">

                                            </div> -->
                                            <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text">
                                                <h6 class="font-weight-bolder kova-light ctrl-size-3">Project completed: {{savedTalent.ProjectsCompleted}}</h6>
                                                <h6 class="font-weight-bolder kova-light ctrl-size-3">Team Work: 4</h6>
                                            <div class="pt-0 mt-1 mt-md-5 pt-md-5">
                                                <font-awesome-icon :icon="['fas', 'bookmark']" class="kova-light" style="font-size: 24px;color:#FE9816"></font-awesome-icon>
                                            </div>
                                            <!-- <h6>{{work.hours}} hours </h6> -->
                                            <!-- <span class="ml-2"><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span> -->

                                            </div>
                                        </div>
                                        <hr>
                                        </div>
                                        
                                    </div>
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4 px-0">
                    <div class="pt-2 mt-3"></div>
                    <div class="ml-2" style="position: sticky; top: 75px">
                        <Notifications />
                        <Messages />
                    </div>
                </div>
            </div>
            
            
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Notifications from '@/components/Notifications.vue'
import Messages from '@/components/Messages.vue'
import { computeExperienceLevel } from "@/helpers/compute.js";

export default {
  name: 'saved',
  components: {
   Navbar, Footer, Notifications, Messages
  },
  data(){
      return {
        loading: true,
        error: null,
        savedTalents: [],
        EngagedTalents: [],
        skills: [
                'Laravel Framework', 'Nodejs','Golang','jQuery', 'JavaScript','database', 'Modeling','Vue.js','Express.js', 'Ext JS', 'Docker'
            ],
        workHistory: [
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19},
            ],
            proSkills: [
                'Database','Modeling', 'Vue.js' 
            ],
            mileStone: [
                {title: 'Login Setub', amount: 210},
                {title: 'API Integration', amount: 89},
                {title: 'Front - End', amount: 400},
                {title: 'Back - End', amount: 600},
                {title: 'Design sign up and user authentication package', amount: 50},
                
            ],
            otherDetails: false,
            showmore: true,
      }
  },
  methods: {
        computeLevel(level) {
        return computeExperienceLevel(level);
        },
        mergeSkills(CoreTechstack, OtherCoreTechstacks) {
        const array = CoreTechstack.split(',');
        if (OtherCoreTechstacks !== null) {
        for (let i = 0; i < OtherCoreTechstacks.length; i++) {
            array.push(OtherCoreTechstacks[i]);
        }
        }
        return array;
        },
        showOtherDetails(){
            this.otherDetails = !this.otherDetails
            this.showmore = false
        },
        showLessDetails(){
            this.otherDetails = !this.otherDetails
            this.showmore = true
        }
  },
  mounted() {
    const param = {
      clientID: localStorage.getItem("id"),
    };
    this.$store
      .dispatch("profiles/getClientProfile", param)
      .then(resp => {
        this.savedTalents = resp.data.SavedTalents;
        this.EngagedTalents = resp.data.EngagedTalents;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.message;
        this.loading = false;
      });

  }
}
</script>
<style scoped>
.kova-text{
    color: #20409a;
}
.add-rounded{
    border-radius: 10px;
}
.bg-skills{
    background-color: #dde;
}
.incr-font-1{
    font-size: 20px;
    font-style: italic;
}
.kova-id{
    width: 100px;
    height: 20px;
    background-color: #4BB38E;
    border-radius: 5px;
}
.icon-size{
    font-size: 25px;
}
.btn-kovatek{
  background-color: #20409A;
  font-weight: bold;
  outline: 0;
  border: 0;
  width: 255px;
  height: 45px;
  color: #fff;
  border-radius: 30px;
  transition: .25s;
  font-size: 18px;
}
.btn-kovatek:hover{
  background-color: #06216d;
  color: #fff;
}
.bg-kovatek{
  background-color: #20409A;
}
.img-height{
    width: 90px;
    height: 90px;
}
.icon-env{
    font-size: 20px;
}
.ctrl-size{
    font-size: 16px;
}
.intermediate{
    color:rgb(148, 194, 20);
    font-size: 12px;
}
.ctrl-size-1{
    font-size: 20px
}
.ctrl-size-2{
    font-size: 12px;
}
.ctrl-size-3{
    font-size: 14px;
}
.bg-skills{
    background-color: #4BB38E;
    color: #fff
}
@media screen and (min-width: 992px) and (max-width: 1325px){
    
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .employer-name{
        font-size: 18px;
    } 
    .img-height{
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   
}

@media screen and (max-width: 767px){
    .float-text{
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6{
        float: left;
    }
}
/* 
@media screen and (max-width: 550px){
    
} */
</style>
